import EquipmentListPriceComponent from '../equipment-list-price/EquipmentListPrice';
import { styled } from '@mui/material';

export const EquipmentListPrice = styled(EquipmentListPriceComponent)`
  width: 100%;
`;
